export enum TileCategories {
    Standard = 'standard',
    RevenueAttribution = 'revenueAttribution',
    DigitalAttribution = 'digitalAttribution'
}
